function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { cloneElement, isValidElement } from 'react';
import { mergeRefs } from '../../../utils';
import { useBaseMenuContext } from '../hooks';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
// Using `forwardRef` from `React` because the trigger can be any HTML element.
export var Trigger = /*#__PURE__*/React.forwardRef((_ref, propRef) => {
  var {
    trigger,
    isDisabled,
    isReadOnly
  } = _ref;
  var {
    getReferenceProps,
    refs
  } = useBaseMenuContext();
  var ref = mergeRefs([refs.setReference, propRef]);
  var inactive = isDisabled || isReadOnly;
  var buttonProps = {
    'aria-disabled': isDisabled,
    'data-readonly': isReadOnly || null,
    ref,
    tabIndex: inactive ? -1 : 0
  };

  if ( /*#__PURE__*/isValidElement(trigger)) {
    return /*#__PURE__*/cloneElement(trigger, _objectSpread(_objectSpread({
      role: 'button'
    }, getReferenceProps(_objectSpread(_objectSpread({
      onClick: e => {
        e.stopPropagation();
      }
    }, buttonProps), trigger.props))), inactive && {
      onClick: undefined
    }));
  }

  return /*#__PURE__*/_jsx(_Fragment, {
    children: trigger
  });
});
//# sourceMappingURL=Trigger.js.map